var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15.1667C22.4991 17.1113 21.7262 18.976 20.3512 20.3512C18.976 21.7262 17.1113 22.4991 15.1667 22.5H0.510286C0.510286 21.537 0.699976 20.5834 1.06851 19.6937C1.43704 18.804 1.97721 17.9956 2.65819 17.3146C3.33914 16.6336 4.14757 16.0935 5.03729 15.7249C5.92702 15.3565 6.8806 15.1667 7.84363 15.1667H15.1769V7.83335C17.1198 7.83697 18.9819 8.61106 20.3549 9.98584C21.7277 11.3606 22.4991 13.2238 22.5 15.1667ZM15.1667 7.83335C17.1113 7.83244 18.976 7.05952 20.3512 5.68445C21.7262 4.30937 22.4991 2.44464 22.5 0.5H7.83335C5.88843 0.5 4.02317 1.27263 2.64789 2.64789C1.27263 4.02317 0.5 5.88843 0.5 7.83335C0.5 9.77826 1.27263 11.6435 2.64789 13.0188C4.02317 14.3941 5.88843 15.1667 7.83335 15.1667V7.83335H15.1667Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScMark);
export default __webpack_public_path__ + "static/media/sc-mark.520bd41b921b084a4580f1821b7e6447.svg";
export { ForwardRef as ReactComponent };